import { render, staticRenderFns } from "./GFGeneralSettings.vue?vue&type=template&id=3b9dd18a&scoped=true"
import script from "./GFGeneralSettings.vue?vue&type=script&lang=js"
export * from "./GFGeneralSettings.vue?vue&type=script&lang=js"
import style0 from "./GFGeneralSettings.vue?vue&type=style&index=0&id=3b9dd18a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9dd18a",
  null
  
)

export default component.exports